import { normalizeActionTag } from 'state/aiModels'

const CLIENT_SIDE_ONLY_ACTION_TAGS = new Set(['pay'])

export function actionProducesGeneratedOutput(actionTag: string | null | undefined): boolean {
    return !CLIENT_SIDE_ONLY_ACTION_TAGS.has(normalizeActionTag(actionTag))
}
